module.exports = __webpack_public_path__ + "img/dinapsis-logo-background.1deae7ac.svg";